<template lang="pug">
.dawn-page-section
  .title-area
    h1.page-title {{ title }}
    p.page-subtitle(v-if='subtitle') {{ subtitle }}
  .page-section-main
    slot
</template>

<script>

export default {
  name: 'ed-section',
  props: {
    title: String,
    subtitle: String
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

.dawn-page-section {
  h1.page-title {
    font-size: 1.1em;
    margin-bottom: 1em;
    color: $border;
  }
  background: $background-light;
  opacity: .5;
  padding: 1em;
  margin: 1em 0em;

  &.active {
    opacity: 1;
  }

  .page-section-main {
    display: flex;
    flex-wrap: wrap;
  }
}

</style>



// WEBPACK FOOTER //
// index.vue?1c060fa9